import { Suspense, lazy } from "react";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { routes } from "../constants";
import store from "../store/store";
import { isBlast, isTech } from "../utils";
import {
	CustomQueryClientProvider,
	ErrorBoundary,
	Preloader,
	oidcConfig,
} from ".";
import { debugUtils } from "../api/api";

const RouterSwitch = lazy(() => import("../routerSwitch"));
const RouterSwitchBlast = lazy(() => import("../routerSwitchBlast"));

export const TheNeedsBe = ({ children }: { children: any }) => (
	<AuthProvider {...oidcConfig}>
		<Provider store={store}>
			<CustomQueryClientProvider>
				<BrowserRouter>
					<ErrorBoundary>{children}</ErrorBoundary>
				</BrowserRouter>
			</CustomQueryClientProvider>
		</Provider>
	</AuthProvider>
);

export const App = () => {
	const queryParams = new URLSearchParams(window.location.search);
	const userId = queryParams.get("getStarted");
	if (import.meta.env.DEV) {
		// @ts-ignore
		window.debugAuth = debugUtils;
	}

	if (userId) {
		const newUrl =
			(isTech
				? import.meta.env.VITE_STS_AUTHORITY_TECH
				: import.meta.env.VITE_STS_AUTHORITY) +
			routes.login.path +
			"?userId=" +
			userId +
			"&returnUrl=" +
			encodeURI(window.location.href.split("?")[0]);

		window.location.replace(newUrl);

		return <Preloader />;
	}
	console.log(import.meta.env.VITE_MODE);

	if (isBlast)
		return (
			<TheNeedsBe>
				<Suspense fallback={<Preloader />}>
					<RouterSwitchBlast />
				</Suspense>
				<ToastContainer />
			</TheNeedsBe>
		);

	return (
		<TheNeedsBe>
			<Suspense fallback={<Preloader />}>
				<RouterSwitch />
			</Suspense>
			<ToastContainer />
		</TheNeedsBe>
	);
};
